import React from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

/* ---------------- ZOHO DETAILS CHECK ---------------- */
const hasAllZohoDetails = (user) => {
  if (!user) return false;

  const requiredFields = [
    "zoho_access_token",
    "zoho_client_id",
    "zoho_client_secret",
    "zoho_id",
    "zoho_org_id",
    "zoho_redirect_uri",
    "zoho_refresh_token",
  ];

  return requiredFields.every(
    (key) => user[key] !== null && user[key] !== undefined && user[key] !== ""
  );
};

/* ---------------- COMPONENT ---------------- */
export default function AccessBlockedModal({
  user,
  allowedRoles = [2], // default → company
  title = "Account Details Required",
  message = "You cannot access this page until all account details are provided.",
  subMessage = "Please contact support or complete integration to continue.",
  onBack,
}) {
  const navigate = useNavigate();

  if (!user) return null;

  const userRole = Number(user.role);

  // ✅ internal decision
  const shouldBlock =
    allowedRoles.includes(userRole) && !hasAllZohoDetails(user);

  if (!shouldBlock) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md text-center">
        <h2 className="text-lg font-bold text-slate-900">
          {title}
        </h2>

        <p className="mt-2 text-sm text-slate-600">
          {message}
        </p>

        {subMessage && (
          <p className="mt-2 text-xs text-slate-500">
            {subMessage}
          </p>
        )}

        <button
          type="button"
          onClick={onBack || (() => navigate(-1))}
          className="mt-4 inline-flex items-center gap-2 rounded-xl border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100"
        >
          <ArrowLeft className="h-4 w-4" />
          Go Back
        </button>
      </div>
    </div>
  );
}
